import { Injectable } from '@angular/core';

@Injectable()
export class DateUtils {

    public formatDateYYYYMMDD( date: Date ): string {
        return date.toLocaleString( 'default', { year: 'numeric' } )
            + '-' + date.toLocaleString( 'default', { month: '2-digit' } ) + '-' + date.toLocaleString( 'default', { day: '2-digit' } );
    }

}
